import { fetchGet } from "@/utils/request";

export default {
  getSituationList() {
    return fetchGet("/elecSituation/getSituationList");
  },
};
